import React from "react";
import classes from "./Pagination.module.scss";
import Chevron from "../Icons/Chevron";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination = ({ currentPage, totalPages, onPageChange }: PaginationProps) => {
  const leftBtnClickHandler = () => {
    if (currentPage === 1) return;
    onPageChange(currentPage - 1);
  };

  const rightBtnClickHandler = () => {
    if (currentPage === totalPages) return;
    onPageChange(currentPage + 1);
  };

  const pageBtnClickHandler = (page: number) => () => {
    onPageChange(page);
  };

  if (totalPages <= 1) return null;

  return (
    <div className={classes["pagination-container"]}>
      <button
        className={`${classes["pagination-left-button"]} ${currentPage === 1 ? classes["button-disabled"] : ""}`}
        onClick={leftBtnClickHandler}
      >
        <Chevron />
      </button>
      <div className={classes["pagination-page-buttons-container"]}>
        {Array(totalPages)
          .fill(0)
          .map((_, index) => (
            <button
              key={index}
              className={`${classes["pagination-page-button"]} ${currentPage === index + 1 ? classes["pagination-page-button-active"] : ""}`}
              style={currentPage > 3 ? { transform: `translateX(-${(currentPage - 2) * 64}px)` } : {}}
              onClick={pageBtnClickHandler(index + 1)}
            >
              {index + 1}
            </button>
          ))}
      </div>
      <button
        className={`${classes["pagination-right-button"]} ${currentPage === totalPages ? classes["button-disabled"] : ""}`}
        onClick={rightBtnClickHandler}
      >
        <Chevron />
      </button>
    </div>
  );
};

export default Pagination;
